// RESULTADOS-06H: color del badge de estado del resultado, automático por nombre.
//   Pendiente          -> rojo
//   Pendiente Informe  -> azul
//   Finalizado         -> verde
//   Cancelado          -> naranja
// Se usa tanto en la grilla (GridResultadoExamen) como en el modal
// (ModalResultadoExamen). Devuelve estilos inline para tener control exacto del
// tono (Bootstrap no trae "naranja" como variante de badge).

const MAPA = {
    "pendiente": { bg: "#dc3545", fg: "#fff" },          // rojo
    "pendiente informe": { bg: "#0d6efd", fg: "#fff" },  // azul
    "finalizado": { bg: "#198754", fg: "#fff" },         // verde
    "cancelado": { bg: "#fd7e14", fg: "#fff" },          // naranja
};

const NEUTRO = { bg: "#6c757d", fg: "#fff" };

export function colorEstado(nombre) {
    const key = String(nombre || "").trim().toLowerCase();
    return MAPA[key] || NEUTRO;
}

// Devuelve props para un <span className="badge" ...>. NO se usa <Badge bg="…">
// de react-bootstrap: sus clases `bg-*` traen `!important` y ganan sobre el
// style inline -> todos los badges salían azules (bg-primary por defecto).
export function estiloEstado(nombre) {
    const c = colorEstado(nombre);
    return { backgroundColor: c.bg, color: c.fg };
}

export default estiloEstado;
